export default {
  mounted() {
    this.initHandlers();
  },

  watch: {
    product() {
      this.initHandlers();
    },
  },

  methods: {
    initHandlers() {
      this.$nextTick(() => {
        this.createFaqHandlers();
        this.createSpoilerHandlers();
      });
    },

    createSpoilerHandlers() {
      const buttons = Array.from(document.querySelectorAll('.article-spoiler__read-more'));

      buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const spoilerId = e.target.getAttribute('data-spoiler-id');
          const spoiler = document.querySelector(`.article-spoiler[data-spoiler-id="${spoilerId}"]`);
          spoiler.classList.add('article-spoiler--open');
        });
      });
    },

    createFaqHandlers() {
      const buttons = Array.from(document.querySelectorAll('.article-faq'));

      buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.target.classList.toggle('article-faq--closed');
        });
      });
    },
  },
};
